import React from "react";
import { checkToken } from "../../Helpers";
import WelcomeView from "../WelcomeView";
import AgeGate from "../AgeGate";
import LogoutView from "../LogoutView";
import { useLocation, Navigate } from "react-router";
import MaintenanceBreak from "../../components/MaintenanceBreak";
import AgeGateFailed from "../AgeGateFailed";
import TokenLoginPage from "../TokenLoginPage";
import QrLanding from "../QrLanding";

export default function PrivateRoute({ children }) {
  const { pathname } = useLocation();

  if (pathname.startsWith("/qr-register") || pathname.startsWith("/qrv")) {
    const params = new URL(window.location.href).searchParams;
    const tokenParam = params.get("token");
    const erParam = params.get("er");

    if (tokenParam) {
      localStorage.setItem("token", tokenParam);
    }
    if (erParam === "true") {
      localStorage.setItem("age-gate", "success");
    }
  }

  const isLoggedIn = checkToken();

  if (isLoggedIn) {
    return <>{children}</>;
  }

  if (pathname.startsWith("/qr-register/")) {
    const code = pathname.slice("/qr-register/".length);
    return <Navigate to={`/qrv/${code}`} replace />;
  }

  if (
    pathname === "/age-gate-failed" &&
    localStorage.getItem("age-gate") === "failed"
  ) {
    return <AgeGateFailed />;
  }

  if (localStorage.getItem("age-gate") !== "success") {
    return <AgeGate />;
  }

  if (pathname === "/logout") {
    return <LogoutView />;
  }

  if (pathname === "/maintenance") {
    return <MaintenanceBreak />;
  }

  if (pathname === "/token") {
    return <TokenLoginPage />;
  }

  if (pathname.startsWith("/qrv/")) {
    return <QrLanding />;
  }

  return <WelcomeView />;
}
